import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  processDetail: {
    paddingTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  circularProgress: {
    color: theme.palette.primary.contrastText,
  },
  footerContainer: {
    alignItems: 'baseline',
    display: 'flex',
    flex: 1,
    flexWrap: 'nowrap',
    justifyContent: 'center',
    paddingTop: theme.spacing(2),
  },
  footerButton: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  stepperContainer: {
    marginBottom: theme.spacing(5),
  },
}));
